import MessagingTab from './messagingTab.view';

export default MessagingTab;
